import { Link as RouterLink, useNavigate } from "react-router-dom";

import {
  FormHelperText,
  Grid,
  InputLabel,
  Link,
  OutlinedInput,
  Stack,
} from "@mui/material";

import { Formik } from "formik";
import * as Yup from "yup";

import LoadingButton from "@mui/lab/LoadingButton";
import AnimateButton from "components/@extended/AnimateButton";

import { SubmitResetPasswordDto } from "interfaces/auth";
import { get } from "lodash";
import { authService } from "services/authService";
import { openNotification } from "utils/notification";

const ForgotPasswordForm = () => {
  const navigate = useNavigate();

  return (
    <>
      <Formik
        initialValues={{
          email: "",
          submit: null,
        }}
        validationSchema={Yup.object().shape({
          email: Yup.string()
            .email("Must be a valid email")
            .max(255)
            .required("Email is required"),
        })}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
          try {
            const dto: SubmitResetPasswordDto = {
              email: values.email,
            };

            await authService.resetPassword(dto);

            openNotification({
              message: "New password has been sent to your email",
              type: "success",
            });

            setStatus({ success: false });
            setErrors({ submit: "fasdfasdfadsf" });
            setSubmitting(false);

            navigate("/auth/login");
          } catch (err) {
            setStatus({ success: false });
            setErrors({ submit: get(err, "message") });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
        }) => (
          <form noValidate onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Stack spacing={1}>
                  <InputLabel htmlFor="email-login">Email Address</InputLabel>
                  <OutlinedInput
                    id="email-login"
                    type="email"
                    value={values.email}
                    name="email"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    placeholder="Enter email address"
                    fullWidth
                    error={Boolean(touched.email && errors.email)}
                  />
                  {touched.email && errors.email && (
                    <FormHelperText
                      error
                      id="standard-weight-helper-text-email-login"
                    >
                      {errors.email}
                    </FormHelperText>
                  )}
                </Stack>
              </Grid>
              {errors.submit && (
                <Grid item xs={12}>
                  <FormHelperText error>{errors.submit}</FormHelperText>
                </Grid>
              )}
              <Grid item xs={12}>
                <AnimateButton>
                  <LoadingButton
                    loading={isSubmitting}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    color="primary"
                  >
                    Submit
                  </LoadingButton>
                </AnimateButton>
              </Grid>
              <Grid textAlign="center" item xs={12}>
                <Link
                  variant="h6"
                  component={RouterLink}
                  to="/auth/login"
                  color="text.primary"
                >
                  Back to Login
                </Link>{" "}
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </>
  );
};

export default ForgotPasswordForm;
